import css from "./Header.module.css";
import { useState } from "react";
import User from "./user/User";
import Overlay from "../../UI/Overlay";

const Header = () => {
	const [isMenuOpen, setIsMenuOpen] = useState(false);

	const menuHandler = (event) => {
		setIsMenuOpen((o) => !o);
	};

	return (
		<header className={css.header}>
			<div className={css["container__header"]}>
				{isMenuOpen && Overlay("black", 0.7, 10, menuHandler)}
				<div
					className={`${css["icon-menu"]} ${!isMenuOpen ? css.open : css.close} bg-center-cover-nr`}
					onClick={menuHandler}
				></div>
				<nav className={`${isMenuOpen ? css.visible : css.hidden} navbar`}>
					<ul className="fwb ">
						<li>
							<a href="/#">Collections </a>
						</li>
						<li>
							<a href="/#">Men </a>
						</li>
						<li>
							<a href="/#">Women </a>
						</li>
						<li>
							<a href="/#">About </a>
						</li>
						<li>
							<a href="/#">Contact </a>
						</li>
					</ul>
				</nav>
				<div className={css.logo}>
					<img src={"/assets/images/logo.svg"} alt="logo" />
				</div>
				<User />
			</div>
		</header>
	);
};

export default Header;
